import { convertTimestampToMilliseconds, timezoneMoment } from 'common/util/time';
import { useTimezone } from 'sdk';
import { FieldRenderer } from 'plugins/types';
import { TIMESTAMP_FIELD } from 'schemas';

import './GenericFieldRenderer.scss';

export const TimestampFieldRenderer: FieldRenderer = ({ value: eventTimeValue, row }) => {
  // DPVZ-2342: Handling the use case where the parser cannot create event.time field
  // use the value from timestamp field instead
  const value = eventTimeValue ? eventTimeValue : row[TIMESTAMP_FIELD];
  const timezone = useTimezone();
  const timestamp = value
    ? timezoneMoment(timezone)(convertTimestampToMilliseconds(value as number)).format('MMM D YYYY HH:mm:ss')
    : '';

  return <div className="GenericFieldRenderer">{timestamp}</div>;
};
